import { AccountSummary } from "@bentolabs/points-worker";
import { useQuery } from "@tanstack/react-query";
import { useAccount } from "wagmi";

export const usePointsAccount = () => {
  const { address } = useAccount();

  return useQuery({
    queryKey: ["points", "accounts", address],
    queryFn: async () => {
      const response = await fetch(`/points/accounts/${address}`);
      const data: AccountSummary = await response.json();

      return data;
    },
    enabled: Boolean(address),
  });
};
